var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"loader"},[_c('span',{staticStyle:{"color":"#555454"}},[_vm._v("Please wait...")])])])
}]

export { render, staticRenderFns }